document.addEventListener('DOMContentLoaded', () => {

  const bundle = document.querySelector('.bundle-v2');

  if (!bundle) return;
  
  const collectionHandle =
    bundle.dataset.collection;

  const grid =
    document.getElementById(
      'bundle-products-grid'
    );

  const loader =
    document.querySelector(
      '.bundle-loader'
    );

  const searchInput =
    document.querySelector(
      '.bundle-search'
    );

  const filterButtons =
    document.querySelectorAll(
      '.bundle-filter'
    );

  let currentSearch = '';

  let currentGender = 'all';

  let cursor = null;

  let hasNextPage = true;

  let loading = false;

  let products = [];
  let modalProducts = [];
  let visibleModalProducts = [];

let modalCursor = null;

let modalHasNextPage = true;

let modalLoading = false;

let modalSearchTerm = '';

 let selectedProducts = [];
let bundleSubmitting = false;

const scrollTopBtn =
  document.querySelector(
    '.bundle-scroll-top'
  );
scrollTopBtn.addEventListener(
  'click',
  () => {

    document
      .querySelector(
        '.bundle-summary'
      )
      .scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

  }
);
function addBundleToCart() {

  const bundleSection =
  document.querySelector(
    '.bundle-summary'
  );

  bundleSection.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });

  if (bundleSubmitting || selectedProducts.length !== totalSlots ||
      selectedProducts.some(product => product.availableForSale !== true)) {
    return;
  }

  bundleSubmitting = true;

  const originalHtml =
    unlockBtn.innerHTML;

  unlockBtn.disabled = true;

  unlockBtn.innerHTML = `
    <span class="bundle-spinner"></span>
    Adding Bundle...
  `;

  stickyCart.disabled = true;

  if (
    !nativeSubmit
  ) {
    bundleSubmitting = false;
    return;
  }
  console.log('SHOWING LOADER');
  setTimeout(
    () => {

      nativeSubmit.click();

    },
    300
  );
  console.log('RESTORING BUTTON');
  setTimeout(() => {

    bundleSubmitting = false;

    unlockBtn.innerHTML =
      originalHtml;

    unlockBtn.disabled = false;

    stickyCart.disabled = false;

  }, 2500);

}
const modal =
  document.querySelector(
    '.bundle-modal'
  );

const modalSearch =
  document.querySelector(
    '.bundle-modal-search'
  );

const modalResults =
  document.querySelector(
    '.bundle-modal-results'
  );

let activeSlot = null;

const totalSlots =
  parseInt(
    bundle.dataset.bundleSlots,
    10
  );

const slotElements =
  document.querySelectorAll(
    '.bundle-slot'
  );

const summaryContainer =
  document.querySelector(
    '.bundle-summary-items'
  );

const progressFill =
  document.querySelector(
    '.bundle-progress-fill'
  );

const selectedCount =
  document.querySelector(
    '.bundle-selected-count'
  );

const footerCount =
  document.querySelector(
    '.footer-count'
  );
const summaryItems =
  document.querySelector(
    '.bundle-summary-items'
  );
const unlockBtn =
  document.querySelector(
    '.bundle-unlock-btn'
  );
  const bundleUidInput =
  document.querySelector(
    '.bundle-uid'
  );
  const stickyCart =
  document.querySelector(
    '.bundle-sticky-cart'
  );

  const nativeSubmit =
  document.querySelector(
    '.product-form__submit'
  );
  console.log('ADD BUNDLE CALLED');

stickyCart.addEventListener(
  'click',
  addBundleToCart
);

unlockBtn.addEventListener(
  'click',
  addBundleToCart
);
  /* -------------------------
     Storefront API
  ------------------------- */
  stickyCart.addEventListener(
  'click',
  async () => {

    if (
      stickyCart.disabled
    ) {
      return;
    }

    stickyCart.disabled =
      true;

    stickyCart.textContent =
      'Adding...';

    const form =
      document.getElementById(
        bundle.dataset.formId
      );

    if (!form) {

      stickyCart.disabled =
        false;

      stickyCart.textContent =
        'Add Bundle To Cart';

      return;

    }

    try {

      const formData =
        new FormData(form);

      const response =
        await fetch(
          '/cart/add.js',
          {
            method:'POST',
            body:formData
          }
        );

      if (
        !response.ok
      ) {
        throw new Error();
      }

      stickyCart.textContent =
        'Added ✓';

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh'
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:open'
        )
      );

      setTimeout(
        () => {

          stickyCart.disabled =
            false;

          stickyCart.textContent =
            'Add Bundle To Cart';

        },
        1500
      );

    }

    catch(error){

      stickyCart.disabled =
        false;

      stickyCart.textContent =
        'Add Bundle To Cart';

      console.error(error);

    }

  }
);
  async function storefrontQuery(query) {

    const response = await fetch(
      `https://${window.bundleStorefront.domain}/api/2025-01/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',

          'X-Shopify-Storefront-Access-Token':
            window.bundleStorefront.token
        },
        body: JSON.stringify({
          query
        })
      }
    );

    return response.json();

  }
  function generateBundleUID() {

    return (
      Date.now() +
      '-' +
      Math.random()
        .toString(36)
        .substring(2,10)
    );

  }
  /* -------------------------
     Load Products
  ------------------------- */

  async function loadProducts(reset = false) {

    if (reset) {

      products = [];

      cursor = null;

      hasNextPage = true;

    }

    if (loading) return;

    if (!hasNextPage && !reset) return;

    loading = true;

    loader.hidden = false;

    if (reset) {

      cursor = null;

      hasNextPage = true;

      products = [];

      grid.innerHTML = '';

    }

    const after =
      cursor
        ? `, after: "${cursor}"`
        : '';

    const query = `
    {
      collection(
        handle: "${collectionHandle}"
      ) {

        products(
          first: 24
          ${after}
        ) {

          pageInfo {

            hasNextPage

            endCursor

          }

          edges {

            node {

              id

              availableForSale

              title

              handle

              featuredImage {
                url
              }

              originalImage:
              metafield(
                namespace:"custom"
                key:"original_image"
              ) {
                reference {
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                }
              }

              fragranceName:
              metafield(
                namespace:"custom"
                key:"fragrance_name"
              ) {
                value
              }

              gender:
              metafield(
                namespace:"custom"
                key:"gender"
              ) {
                value
              }

            }

          }

        }

      }

    }
    `;

    try {

      const result =
        await storefrontQuery(
          query
        );

      const collection =
        result.data.collection;

      if (!collection) {

        loading = false;

        loader.hidden = true;

        return;

      }

      const responseProducts =
        collection.products;

      cursor =
        responseProducts.pageInfo.endCursor;

      hasNextPage =
        responseProducts.pageInfo.hasNextPage;

      responseProducts.edges.forEach(
        edge => {

          const product =
            edge.node;

          if (product.availableForSale !== true) return;

          products.push({

            availableForSale: product.availableForSale,

            id:
              product.id,

            productId:
              product.id
                .split('/')
                .pop(),

            title:
              product.title,

            fragranceName:
                product.fragranceName?.value || '',

            fullTitle:
            (
                product.fragranceName?.value || ''
            ) +
            ' - ' +
            product.title,

            gender:
              (
                product.gender?.value || ''
              )
                .toLowerCase()
                .trim(),

            image:
              product.featuredImage?.url || '',

            originalImage:
              product.originalImage
                ?.reference
                ?.image
                ?.url || '',

          });

        }
      );

      renderProducts();

      // Skip sold-out pages so available products further down remain reachable.
      if (hasNextPage && !responseProducts.edges.some(edge => edge.node.availableForSale === true)) {
        loading = false;
        await loadProducts();
      }

    }

    catch(error){

      console.error(error);

    }

    loading = false;

    loader.hidden = true;

  }
  async function loadModalProducts(
    reset = false
  ) {

    if (modalLoading) return;

    if (
      !modalHasNextPage &&
      !reset
    ) {
      return;
    }

    modalLoading = true;

    if (reset) {

      modalCursor = null;

      modalHasNextPage = true;

      modalProducts = [];

      modalResults.innerHTML = '';

    }

    const after =
      modalCursor
        ? `, after: "${modalCursor}"`
        : '';

    const searchQuery =
      modalSearchTerm
        ? `query: "${modalSearchTerm}",`
        : '';

    const query = `
    {
      collection(
        handle: "${collectionHandle}"
      ) {

        products(
          first: 30
          ${after}
        ) {

          pageInfo {
            hasNextPage
            endCursor
          }

          edges {

            node {

              id

              availableForSale

              title

              featuredImage {
                url
              }

              originalImage:
              metafield(
                namespace:"custom"
                key:"original_image"
              ) {
                reference {
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                }
              }
              
              fragranceName:
              metafield(
                namespace:"custom"
                key:"fragrance_name"
              ) {
                value
              }

            }

          }

        }

      }

    }
    `;

    try {

      const result =
        await storefrontQuery(
          query
        );

      const response =
        result.data.collection.products;

      modalCursor =
        response.pageInfo.endCursor;

      modalHasNextPage =
        response.pageInfo.hasNextPage;

      response.edges.forEach(
        edge => {

          const product =
            edge.node;

          if (product.availableForSale !== true) return;

          modalProducts.push({

            availableForSale: product.availableForSale,

            id:
              product.id,

            productId:
              product.id
                .split('/')
                .pop(),

            title:
              product.title,

            fragranceName:
              product.fragranceName?.value || '',

            fullTitle:
              (
                product.fragranceName?.value || ''
              ) +
              ' - ' +
              product.title,

            image:
              product.featuredImage?.url || '',

            originalImage:
              product.originalImage
                ?.reference
                ?.image
                ?.url || '',  

          });

        }
      );

      renderModalProducts(
        modalProducts
      );

      if (modalHasNextPage && !response.edges.some(edge => edge.node.availableForSale === true)) {
        modalLoading = false;
        await loadModalProducts();
      }

    }

    catch(error){

      console.error(error);

    }

    modalLoading = false;

  }
  /* -------------------------
     Render Products
  ------------------------- */

function renderProducts() {

    const bundleFull =
    selectedProducts.length >=
    totalSlots;

    let filtered =
      products.filter(product => product.availableForSale === true);

    if (
      currentGender !== 'all'
    ) {

      filtered =
        filtered.filter(
          product =>
            product.gender ===
            currentGender
        );

    }

    if (
      currentSearch
    ) {

      const search =
        currentSearch
          .toLowerCase();

      filtered =
        filtered.filter(
          product => {

            const text =
              (
                product.fragranceName +
                ' ' +
                product.title
              )
              .toLowerCase();

            return text.includes(
              search
            );

          }
        );

    }

    grid.innerHTML =
    filtered.map(
    product => {

      const selected =
        Array.from(
          slotElements
        ).some(
          slot =>
            slot.dataset.productId ===
            product.productId
        );

      const bundleFull =
        selectedProducts.length >=
        totalSlots;

      return `
        <div
          class="bundle-card"
          data-product-id="${product.productId}"
        >

          <div
            class="bundle-card-image"
          >

            <img
              src="${product.image}"
              alt="${product.title}"
            >
             ${
                product.originalImage
                  ? `
                  <img
                    class="bundle-card-original"
                    src="${product.originalImage}"
                    alt=""
                  >
                  `
                  : ''
              }
          </div>

          <div
            class="bundle-card-body"
          >

            <div
              class="bundle-card-title"
            >

              ${product.fragranceName}

            </div>

            <div
              class="bundle-card-subtitle"
            >

              ${product.title}

            </div>

            <div
              class="bundle-card-gender"
            >

              ${product.gender}

            </div>

            <button
              type="button"
              class="bundle-card-button ${selected ? 'selected' : ''}"
              data-product-id="${product.productId}"
              ${bundleFull && !selected ? 'disabled' : ''}
            >
              ${selected ? 'Selected ✓' : 'Add'}
            </button>

          </div>

        </div>
      `;
    }
  )
      .join('');

  }
  
  function updateProgress() {

    const count =
        selectedProducts.length;

    const percent =
        (
        count /
        totalSlots
        ) * 100;

    progressFill.style.width =
        `${percent}%`;

    selectedCount.textContent =
        count;

    footerCount.textContent =
        count;

    const remaining =
        totalSlots - count;

    if (
        remaining > 0
    ) {
        bundleUidInput.value = '';
        document
        .querySelector(
          '.bundle-sticky-cart'
        )
        .disabled = true;
        unlockBtn.disabled =
        true;

        unlockBtn.classList.remove(
        'ready'
        );

        unlockBtn.innerHTML =
        `
        <span>
            Select ${remaining}
            more fragrance${
            remaining > 1
                ? 's'
                : ''
            } to unlock
        </span>
        `;

    } else {
        document
        .querySelector(
          '.bundle-sticky-cart'
        )
        .disabled = false;
        unlockBtn.disabled =
          false;

        unlockBtn.classList.add(
          'ready'
        );

        if (
          !bundleUidInput.value
        ) {

          bundleUidInput.value =
            generateBundleUID();

        }

        unlockBtn.innerHTML =
          `
          <span>
            ✓ Bundle Ready
          </span>
          `;

    }

    }

    function updateSummary() {

    summaryItems.innerHTML =
        selectedProducts
        .map(
            product => `
            <div
                class="bundle-summary-item"
            >
                ✓ ${product.fullTitle}
            </div>
            `
        )
        .join('');

    }

    function fillFirstEmptySlot(
    product
    ) {

    const slot =
        Array.from(
        slotElements
        ).find(
        item =>
            !item.dataset.productId
        );

    if (!slot) return;

    slot.dataset.productId =
        product.productId;

    slot.querySelector(
      '.bundle-slot-text'
    ).textContent =
      product.fullTitle;
    
    slot.querySelector(
      '.bundle-slot-text'
    ).title =
      product.fullTitle;

    const thumb =
      slot.querySelector(
        '.bundle-slot-thumb'
      );

    thumb.src =
      product.image;

    thumb.hidden =
      false;

    slot.querySelector(
        '.bundle-slot-name'
    ).value =
        product.fullTitle;

    slot.querySelector(
      '.bundle-slot-image'
    ).value =
      product.image;

    slot.querySelector(
        '.bundle-slot-id'
    ).value =
        product.productId;

    slot.querySelector(
      '.bundle-slot-image'
    ).value =
      product.image;

    slot.querySelector(
        '.bundle-remove'
    ).hidden =
        false;

    }

  function renderModalProducts(items) {

  visibleModalProducts = items.filter(product => product.availableForSale === true);

  modalResults.innerHTML =
    visibleModalProducts.map(
      product => `
        <div
          class="bundle-modal-item"
          data-product-id="${product.productId}"
        >

          <img
            src="${product.image}"
            alt="${product.fullTitle}"
          >

          <div>

            <strong>
              ${product.fragranceName}
            </strong>

            <div>
              ${product.title}
            </div>

          </div>

        </div>
      `
    ).join('');

}  
  /* -------------------------
     Search
  ------------------------- */

  let searchTimeout;

  searchInput.addEventListener(
    'input',
    function(){

      clearTimeout(
        searchTimeout
      );

      searchTimeout =
        setTimeout(
          async () => {

            const search =
              this.value.trim();

            if (!search) {

              currentSearch = '';

              loadProducts(true);

              return;

            }

            try {

              const query = `
              {
                products(
                  first: 50
                  query: "tag:perfume available_for_sale:true ${search}"
                ) {

                  edges {

                    node {

                      id

                      availableForSale

                      title

                      featuredImage {
                        url
                      }

                      fragranceName:
                      metafield(
                        namespace:"custom"
                        key:"fragrance_name"
                      ) {
                        value
                      }

                      gender:
                      metafield(
                        namespace:"custom"
                        key:"gender"
                      ) {
                        value
                      }

                    }

                  }

                }

              }
              `;

              const result =
                await storefrontQuery(
                  query
                );

              products =
                result.data.products.edges.filter(edge => edge.node.availableForSale === true).map(
                  edge => {

                    const product =
                      edge.node;

                    return {

                      availableForSale: product.availableForSale,

                      id:
                        product.id,

                      productId:
                        product.id
                          .split('/')
                          .pop(),

                      title:
                        product.title,

                      fragranceName:
                        product.fragranceName?.value || '',

                      fullTitle:
                        (
                          product.fragranceName?.value || ''
                        ) +
                        ' - ' +
                        product.title,

                      gender:
                        (
                          product.gender?.value || ''
                        )
                          .toLowerCase()
                          .trim(),

                      image:
                        product.featuredImage?.url || '',
                      
                      originalImage:
                        product.originalImage
                          ?.reference
                          ?.image
                          ?.url || '',

                    };

                  }
                );

              renderProducts();

            }

            catch(error){

              console.error(error);

            }

          },
          400
        );

    }
  );

  /* -------------------------
     Filters
  ------------------------- */

  filterButtons.forEach(
    button => {

      button.addEventListener(
        'click',
        () => {

          filterButtons.forEach(
            b =>
              b.classList.remove(
                'active'
              )
          );

          button.classList.add(
            'active'
          );

          currentGender =
            button.dataset.gender
              .toLowerCase();

          renderProducts();

        }
      );

    }
  );
  
  grid.addEventListener(
    'click',
    e => {

        const button =
        e.target.closest(
            '.bundle-card-button'
        );

        if (!button) return;

        const productId =
        button.dataset.productId;

        const product =
        products.find(
            p =>
            p.productId ===
            productId
        );

        if (!product || product.availableForSale !== true) return;

        if (
        selectedProducts.some(
            p =>
            p.productId ===
            productId
        )
        ) {
        return;
        }

        if (
        selectedProducts.length >=
        totalSlots
        ) {
        return;
        }
        if (
          Array.from(slotElements).some(
            slot =>
              slot.dataset.productId ===
              product.productId
          )
        ) {

          return;

        }
        selectedProducts.push(
        product
        );
        console.log(
        'selectedProducts',
        selectedProducts
        );
        fillFirstEmptySlot(
        product
        );

        updateProgress();

        updateSummary();

        renderProducts();

    }
    );

    slotElements.forEach(
    slot => {

        slot.querySelector(
          '.bundle-remove'
        ).addEventListener(
          'click',
          e => {

            e.preventDefault();

            e.stopPropagation();

            const productId =
            slot.dataset.productId;

            if (!productId)
            return;

            selectedProducts =
            selectedProducts.filter(
                product =>
                product.productId !==
                productId
            );

            delete slot.dataset.productId;

            slot.querySelector(
              '.bundle-slot-text'
            ).textContent =
              'Select fragrance...';

            slot.querySelector(
              '.bundle-slot-text'
            ).title =
              '';

            const thumb =
              slot.querySelector(
                '.bundle-slot-thumb'
              );

            if (thumb) {

              thumb.src = '';

              thumb.hidden = true;

            }

            slot.querySelector(
            '.bundle-slot-name'
            ).value =
            '';

            slot.querySelector(
            '.bundle-slot-id'
            ).value =
            '';
            slot.querySelector(
              '.bundle-slot-image'
            ).value =
            '';
            slot.querySelector(
            '.bundle-remove'
            ).hidden =
            true;
            
            updateProgress();

            updateSummary();

            renderProducts();

        }
        );

    }
    );

    slotElements.forEach(
      slot => {

        slot.querySelector(
          '.bundle-slot-select'
        ).addEventListener(
          'click',
          () => {

            activeSlot = slot;

            modal.hidden = false;

            if (
              modalProducts.length === 0
            ) {

              loadModalProducts(
                true
              );

            }

          }
        );

      }
    );
    document
      .querySelector(
        '.bundle-modal-overlay'
      )
      .addEventListener(
        'click',
        () => {

          modal.hidden = true;

        }
      );

      let modalSearchTimeout;

      modalSearch.addEventListener(
        'input',
        function() {

          clearTimeout(
            modalSearchTimeout
          );

          modalSearchTimeout =
            setTimeout(
              async () => {

                const search =
                  this.value.trim();

                if (!search) {

                  modalSearchTerm = '';

                  loadModalProducts(
                    true
                  );

                  return;

                }

                try {

                  const query = `
                  {
                    products(
                      first: 25
                      query: "tag:perfume available_for_sale:true ${search}"
                    ) {

                      edges {

                        node {

                          id

                          availableForSale

                          title

                          featuredImage {
                            url
                          }

                          fragranceName:
                          metafield(
                            namespace:"custom"
                            key:"fragrance_name"
                          ) {
                            value
                          }

                        }

                      }

                    }

                  }
                  `;

                  const result =
                    await storefrontQuery(
                      query
                    );

                  const searchResults =
                    result.data.products.edges.filter(edge => edge.node.availableForSale === true).map(
                      edge => {

                        const product =
                          edge.node;

                        return {

                          availableForSale: product.availableForSale,

                          id:
                            product.id,

                          productId:
                            product.id
                              .split('/')
                              .pop(),

                          title:
                            product.title,

                          fragranceName:
                            product.fragranceName?.value || '',

                          fullTitle:
                            (
                              product.fragranceName?.value || ''
                            ) +
                            ' - ' +
                            product.title,

                          image:
                            product.featuredImage?.url || ''

                        };

                      }
                    );

                  renderModalProducts(
                    searchResults
                  );

                }

                catch(error){

                  console.error(error);

                }

              },
              400
            );

        }
      );

      modalResults.addEventListener(
        'scroll',
        () => {

          if (
            modalLoading ||
            !modalHasNextPage
          ) {
            return;
          }

          const trigger =
            modalResults.scrollHeight -
            modalResults.clientHeight -
            200;

          if (
            modalResults.scrollTop >
            trigger
          ) {

            loadModalProducts();

          }

        }
      );

      modalResults.addEventListener(
        'click',
        e => {

          const item =
            e.target.closest(
              '.bundle-modal-item'
            );

          if (!item) return;

          const product =
            visibleModalProducts.find(
              p =>
                p.productId ===
                item.dataset.productId
            );

          if (!product || product.availableForSale !== true) return;
          
          const duplicate =
            Array.from(slotElements).some(
              slot =>
                slot !== activeSlot &&
                slot.dataset.productId ===
                product.productId
            );

          if (duplicate) {

            alert(
              'This fragrance has already been selected.'
            );

            return;

          }
          const alreadySelected =
            Array.from(slotElements).some(
              slot =>
                slot !== activeSlot &&
                slot.dataset.productId ===
                product.productId
            );

          if (alreadySelected) {

            alert(
              'This fragrance is already selected.'
            );

            return;

          }

          const existingId =
            activeSlot.dataset.productId;

          if (existingId) {

            selectedProducts =
              selectedProducts.filter(
                p =>
                  p.productId !==
                  existingId
              );

          }

          activeSlot.dataset.productId =
            product.productId;

          activeSlot.querySelector(
            '.bundle-slot-text'
          ).textContent =
            product.fullTitle;

          activeSlot.querySelector(
            '.bundle-slot-text'
          ).title =
            product.fullTitle;

          const thumb =
            activeSlot.querySelector(
              '.bundle-slot-thumb'
            );

          thumb.src =
            product.image;

          thumb.hidden =
            false;

          activeSlot.querySelector(
            '.bundle-slot-name'
          ).value =
            product.fullTitle;

          activeSlot.querySelector(
            '.bundle-slot-id'
          ).value =
            product.productId;

          activeSlot.querySelector(
            '.bundle-remove'
          ).hidden =
            false;

          if (
            !selectedProducts.some(
              p =>
                p.productId ===
                product.productId
            )
          ) {

            selectedProducts.push(
              product
            );

          }

          updateProgress();

          updateSummary();

          renderProducts();

          modal.hidden = true;

        }
      );
  /* -------------------------
     Infinite Scroll
  ------------------------- */

  window.addEventListener(
    'scroll',
    () => {

      if (
        loading ||
        !hasNextPage
      ) {
        return;
      }

      const trigger =
        document.documentElement
          .scrollHeight -
        1200;

      if (
        window.scrollY +
        window.innerHeight >
        trigger
      ) {

        loadProducts();

      }

    }
  );
  
  /* -------------------------
     Init
  ------------------------- */

  loadProducts(true);

});
